import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Heart, Users, Clock } from 'lucide-react';
export function ProofCredibility() {
  const trustPoints = [{
    icon: Heart,
    title: 'Enfoque 100% respetuoso',
    text: 'Basado en crianza consciente y apego seguro.'
  }, {
    icon: Clock,
    title: 'Aplicable desde el día 1',
    text: 'Estrategias claras que puedes usar hoy mismo.'
  }, {
    icon: Users,
    title: 'Para toda la familia',
    text: 'Pensado para mamás, papás y cuidadores.'
  }, {
    icon: BookOpen,
    title: 'Sin promesas irreales',
    text: 'Herramientas honestas para resultados reales.'
  }];
  return <section className="py-24 px-4 bg-[#F5F0E8]" data-id="element-199">
      <div className="max-w-6xl mx-auto" data-id="element-200">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-201">
          <h2 className="font-serif text-3xl md:text-4xl text-[#3D3229] mb-6" data-id="element-202">
            Creado para familias reales como la tuya
          </h2>
          <p className="text-lg text-[#5C4A3A] max-w-2xl mx-auto" data-id="element-203">
            Este pack no es teoría complicada. Es un conjunto de herramientas
            prácticas diseñadas para funcionar en el caos y la belleza de la
            vida real.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-204">
          {trustPoints.map((point, index) => <motion.div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-[#EBE5DB] text-center" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-205">
              <div className="w-12 h-12 bg-[#F5F0E8] rounded-full flex items-center justify-center mb-6 text-[#5A7D60] mx-auto" data-id="element-206">
                <point.icon size={24} data-id="element-207" />
              </div>
              <h3 className="font-serif text-lg text-[#3D3229] mb-3 font-semibold" data-id="element-208">
                {point.title}
              </h3>
              <p className="text-[#5C4A3A] text-sm leading-relaxed" data-id="element-209">
                {point.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}